import { type BranchKey, useDeleteConciseBranch } from '@festina-life/api'
import { useTranslate } from '@festina-life/ui/hooks'

import { useNavigationParams } from '../../../../system/useNavigationParams'
import { useAllConciseBranches } from '../../../../uiModels/branches/useAllConciseBranches'
import { DeleteBranchConfirmationButton } from './DeleteBranchConfirmationButton'

type Props = {
  branchKey: BranchKey
}

export const DeleteBranchButton = ({ branchKey }: Props) => {
  const conciseBranches = useAllConciseBranches()
  const translate = useTranslate()
  const { mutateAsync: deleteBranch, isPending: isDeletingBranch } =
    useDeleteConciseBranch()
  const { branch: currentBranch, server: currentServer } = useNavigationParams()

  const isCurrentlyOnBranch =
    currentBranch === branchKey.name && currentServer === branchKey.server
  const isBranchDeletable = !conciseBranches[branchKey.server]?.some(
    (specification) => specification.baseBranchName === branchKey.name,
  )

  return (
    <DeleteBranchConfirmationButton
      branchKey={branchKey}
      label={translate('branchDetailsPanel.tabs.manage.deleteBranch')}
      confirmationTitle={translate(
        'branchDetailsPanel.tabs.manage.deleteBranch.confirmation.title',
        { branchName: branchKey.name },
      )}
      confirmationDescription={translate(
        'branchDetailsPanel.tabs.manage.deleteBranch.confirmation.description',
      )}
      onDelete={() =>
        deleteBranch({ branchName: branchKey.name, server: branchKey.server })
      }
      isLoading={isDeletingBranch}
      disabled={isCurrentlyOnBranch || !isBranchDeletable}
      isNameConfirmationRequired={false}
    />
  )
}
